<template>
    <div id="Launch">
      <p>{{ message }}</p>
      <div class="imageBox">
         <img :src="imageCode">
      </div>
    </div>
  </template>
  <script>
  import QRCoder from "qrcoder";
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        imageCode:""
      };
    },
    props: ["message","ds_id","channel_id"],
    computed:{
      ...mapGetters({
        wechat_mp_url: "dsInfo/getWechat_mp_url"
      })
    },  
    watch:{
      wechat_mp_url:{
        handler(){
             this.$nextTick(()=>{
              this.makeCodeImage()
             })
         },
         immediate: true
      }
    },
    mounted() {
    },
    methods: {
      makeCodeImage() {
        let xcxurl = ""
        if (this.channel_id) {
            xcxurl = `${this.wechat_mp_url}?channel_id=${this.channel_id}`
          }else {
            xcxurl = `${this.wechat_mp_url}?ds_id=${this.ds_id}`  
          }
          const qrcoder = new QRCoder({
            data: xcxurl,
            size: 240,
          });
          this.imageCode = qrcoder.getDataURL();
      },
    },
  };
  </script>
  
  <style scoped>
  #Launch {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 11000;
    background: #f5f5f5;
    top: 0;
    left: 0;
  }
  
  .img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }
  

  p {
    margin-top: 100px;
    padding: 50px 0;
    text-align: center;
    font-size: 18px;
  }

  .imageBox{
    text-align: center;
  }
  </style>
  


// WEBPACK FOOTER //
// noWatchTips.vue?4b80878c